import React from 'react'
import { LoanLog } from '@matech/thebigpos-sdk'
import { useIntl } from 'react-intl'
import { LoanLogType } from './LoanLogSearchFilters'

export type LoanLogTypeLabelProps = {
	type: LoanLog['type']
}

const LoanLogTypeLabel = ({ type }: LoanLogTypeLabelProps) => {
	const { formatMessage } = useIntl()

	const typeMap: Record<LoanLogType, string> = {
		Loan: formatMessage({ id: 'loan_log.type.loan' }),
		Queue: formatMessage({ id: 'loan_log.type.queue' }),
		POSFlagChanged: formatMessage({
			id: 'loan_log.type.pos_flag_changed',
		}),
		Verification: formatMessage({ id: 'loan_log.type.verification' }),
	}

	return <span>{typeMap[type] || type}</span>
}

export default LoanLogTypeLabel
